type IReducer<V, A> = (v: V, acc: A) => any;

export function compose<T>(...fns: any[]) {
  return (x: T) => fns.reduce((y, f) => f(y), x);
}

export function map<T, R, V>(transformFn: (v: R) => V) {
  return (step: IReducer<T, V>): IReducer<T, R> =>
    (a, c) =>
      step(a, transformFn(c));
}

export function filter<T, R>(predicate: (v: R) => boolean) {
  return (step: IReducer<T, R>) =>
    (a: T, c: R): IReducer<T, R> | T =>
      predicate(c) ? step(a, c) : a;
}
